import { GENERAL_IDENTIFIERS } from '../../types/Identifiers';
export var identifyTag = function (seoTag) {
    var type = seoTag.type;
    switch (type) {
        case 'link': {
            return GENERAL_IDENTIFIERS.LINK;
        }
        case 'meta': {
            if ('property' in seoTag.props) {
                return GENERAL_IDENTIFIERS.OG_TAG;
            }
        }
        // eslint-disable-next-line no-fallthrough
        default: {
            return GENERAL_IDENTIFIERS.STANDARD_META;
        }
    }
};
